import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TabsMobile from "../../__template/TabsMobileComponent";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../config/global";
import SuccesIcon from "../../../assets/images/icon_invoice/success_icon.svg";
import moment from "moment";
import { i18n } from "../../../translations/i18n";
import User from "../../../core/models/user";
import { useAppSelector } from "../../../core/feature/hooks";
import { getDetailInvoiceHistory } from "../../../core/service/api_invoice";

export const InvoiceHistoryDetailComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const user: User = useAppSelector((state) => state.user.user);

  const data = useMemo(() => {
    return location.state.data;
  }, [location]);

  const [detailHistory, setDetailHistory] = useState<any>({});

  const funBg = useMemo(() => {
    var str = "white";
    return "bg-" + str;
  }, []);

  const getTitle = () => {
    if (!data.partialMethod) return "Invoice non Credit";
    if (
      data.partialMethod &&
      (!data.creditDetailPayment || data.creditDetailPayment === null)
    )
      return "Invoice Credit";
    if (data.partialMethod && data.creditDetailPayment)
      return "Invoice Credit per Detail";
    return t("invoice.history");
  };

  const getInvoiceStatus = () => {
    if (data.status === "PAID") return t("INVOICE.paid");
    if (data.status === "UNPAID") return t("INVOICE.unpaid");
    if (data.status === "PARTIAL") return t("INVOICE.partial");
    return data.status;
  };

  const isHasDetailPayment = useMemo(() => {
    if (data?.reference.length) {
      return data?.reference.some((item: any) => item.detailId !== "");
    }
    return false;
  }, [data]);

  const getDetailPaidValue = (detail: any) => {
    if (
      detail.transactionAmount !== 0 &&
      !(detail.amount === detail.paidAmount)
    ) {
      return (
        <span className="">({formatCurrency(detail.transactionAmount)})</span>
      );
    } else if (
      detail.transactionAmount !== 0 &&
      detail.amount === detail.paidAmount
    ) {
      return (
        <div className="flex flex-col">
          <span className="text-blue-700">({t("INVOICE.paid")})</span>
          <span className="">({formatCurrency(detail.transactionAmount)})</span>
        </div>
      );
    } else if (
      detail.transactionAmount === 0 &&
      detail.amount === detail.paidAmount
    ) {
      return <span className="text-blue-700">({t("INVOICE.paid")})</span>;
    }
  };

  // terbayar di reference (total di history ini)
  const totalPaidAmount = data?.reference?.reduce((acc: number, curr: any) => {
    return acc + curr.amount;
  }, 0);

  // total terbayar pada detail paidAmount
  const totalDetailPaidAmount = data.detail.reduce((acc: number, curr: any) => {
    return acc + curr.paidAmount;
  }, 0);

  // total tagihan di invoice ini
  const totalInvoiceAmount = data.detail.reduce((acc: any, current: any) => {
    return acc + (current.amount - current.discount);
  }, 0);

  const lastPaidAmount =
    totalInvoiceAmount - totalDetailPaidAmount - totalPaidAmount;

  useEffect(() => {
    console.log("data", data);
    console.log({
      totalPaidAmount,
      totalDetailPaidAmount,
      totalInvoiceAmount,
    });

    getDetailInvoiceHistory(data.invoiceId, data.transactionId).then((res) => {
      console.log("Detail: ", res.data);
      setDetailHistory(res.data);
    });
    console.log("isHasDetailPayment", isHasDetailPayment);
  }, [data]);

  useEffect(() => {});

  return (
    <>
      <div className="min-h-screen h-full  bg-psp-primary">
        <div className={`px-8 pt-8 pb-3  sticky top-0 z-300 ${funBg}`}>
          <TabsMobile name={`${getTitle()}`} backUrl={"invoice"}></TabsMobile>
        </div>
        <section className="px-4 py-6 flex flex-col top-to-bottom">
          <div className="bg-white rounded-xl shadow-sm font-montserrat my-3 p-4">
            <div className="grid grid-row-1 divide-y text-center">
              <div className="flex flex-col justify-center">
                <img
                  src={SuccesIcon}
                  alt="success"
                  className="w-16 h-16 mx-auto mb-4"
                />
                <span className="text-2xl mb-2">{t("INVOICE.success")}</span>
              </div>

              <div className="">
                <div className="flex flex-col">
                  <span className="text-xs mt-4">{`${t("INVOICE.amount")}`}</span>
                  <span className="text-xl font-semibold">
                    {formatCurrency(detailHistory.amount)}
                  </span>
                </div>
                {data.partialMethod && (
                  <div className="flex justify-between">
                    <div className="flex flex-col">
                      <span className="text-xs mt-4">{t("INVOICE.sisa")}</span>
                      <span className="text-sm font-semibold text-danger">
                        {formatCurrency(detailHistory.remainingAmount)}
                      </span>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-xs mt-4">{t("INVOICE.total")}</span>
                      <span className="text-sm font-semibold">
                        {formatCurrency(detailHistory.invoiceAmount)}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        <section className="px-4 flex flex-col top-to-bottom">
          <div className="bg-white rounded-2xl shadow-sm font-montserrat p-4">
            <span className="text-lg mb-4 font-medium font-medium">
              {t("INVOICE.dataInvoice")}
            </span>
            <div className="flex justify-between items-center gap-2 w-full mt-2">
              <span className="text-xs">{t("INVOICE.parentName")}</span>
              <span className="text-xs">{user.name}</span>
            </div>
            <div className="flex justify-between items-center gap-2 w-full">
              <span className="text-xs">{t("INVOICE.studentName")}</span>
              <span className="text-xs">{data?.callerName}</span>
            </div>
            <div className="flex justify-between items-center gap-2 w-full">
              <span className="text-xs">{t("INVOICE.nis")}</span>
              <span className="text-xs">{data?.callerId}</span>
            </div>
          </div>
        </section>
        <section className="px-4 flex flex-col top-to-bottom mt-2">
          <div className="bg-white rounded-2xl shadow-sm font-montserrat p-4">
            <span className="text-lg mb-4 font-medium">
              {t("INVOICE.detailInvoice")}
            </span>
            <div className="flex justify-between items-start gap-2 w-full mt-2">
              <span className="text-xs ">{t("INVOICE.invoiceName")}</span>
              <span className="text-xs w-1/2">{data?.title}</span>
            </div>
            <div className="flex justify-between items-center gap-2 w-full mt-1">
              <span className="text-xs">{t("INVOICE.date")}</span>
              <span className="text-xs">
                {moment(data?.paymentDate).locale(i18n.language).format("LL")}
              </span>
            </div>
            <div className="flex justify-between items-center gap-2 w-full mt-1">
              <span className="text-xs">{t("INVOICE.limit")}</span>
              <span className="text-xs">
                {moment(data?.dueDate).locale(i18n.language).format("LL")}
              </span>
            </div>
            <div className="flex justify-between items-center gap-2 w-full mt-1">
              <span className="text-xs">{t("INVOICE.invoiceType")}</span>
              <span className="text-xs">{getTitle()}</span>
            </div>
          </div>
        </section>
        <section className="px-4 flex flex-col top-to-bottom mt-2 pb-24">
          <div className="bg-white rounded-2xl shadow-sm font-montserrat p-4">
            <span className="text-lg mb-4 font-medium">
              {t("INVOICE.summary")}
            </span>

            <div className="flex justify-between items-center gap-2 w-full mt-1">
              <span className="text-xs">Status</span>
              <span className="text-xs">{getInvoiceStatus()}</span>
            </div>
            {isHasDetailPayment && (
              <div className="flex flex-col gap-2 mt-3">
                {data.detail.map((d: any) => {
                  return (
                    <>
                      <div className="flex justify-between items-start gap-2 w-full mt-1 border-b border-b-silver">
                        <span className="text-xs w-1/2">{d.title}</span>
                        <div className="text-xs flex flex-col gap-1 no-wrap w/12 text-right">
                          <span>{formatCurrency(d.amount)}</span>
                          <span>{getDetailPaidValue(d)}</span>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            )}
            <div className="flex justify-between items-center gap-2 w-full mt-2">
              <span className="text-xs">{t("INVOICE.total")}</span>
              <span className="text-xs">
                {formatCurrency(detailHistory?.invoiceAmount)}
              </span>
            </div>
            {isHasDetailPayment && (
              <div className="flex justify-between items-center gap-2 w-full mt-1">
                <span className="text-xs">{t("INVOICE.totalPrevPaid")}</span>
                <span className="text-xs">
                  {formatCurrency(detailHistory?.prevPaidAmount)}
                </span>
              </div>
            )}
            <div className="flex justify-between items-center gap-2 w-full mt-1">
              <span className="text-xs">{t("INVOICE.totalpay")}</span>
              <span className="text-xs">{formatCurrency(data?.amount)}</span>
            </div>
            {isHasDetailPayment && (
              <div className="flex justify-between items-center gap-2 w-full mt-1">
                <span className="text-xs">{t("INVOICE.sisa")}</span>
                <span className="text-xs">
                  {formatCurrency(detailHistory?.remainingAmount)}
                  {detailHistory?.remainingAmount === 0 && (
                    <span className="text-success">
                      {" "}
                      ({t("INVOICE.lunas")})
                    </span>
                  )}
                </span>
              </div>
            )}
          </div>
        </section>
        <div className="p-3 bg-psp-primary fixed bottom-0 left-0 w-full">
          <button
            onClick={() => {
              navigate(-1);
            }}
            className={`px-2 py-2.5 rounded-lg font-bold text-xs bg-danger text-white w-full `}
          >
            {t("HOME.close")}
          </button>
        </div>
      </div>
    </>
  );
};
